"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const ButtonCreateNewWork_1 = require("@Components/Buttons/ButtonCreateNewWork");
const permissions_1 = require("@Const/permissions");
const contexts_1 = require("@App/contexts");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const CatalogSearch_1 = __importDefault(require("@Components/CatalogSearch"));
const CatalogCompactWorkItem_1 = __importDefault(require("@Components/WorkItemV2/Catalog/CatalogCompactWorkItem"));
const CatalogExtendedWorkItem_1 = __importDefault(require("@Components/WorkItemV2/Catalog/CatalogExtendedWorkItem"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const CatalogMobileSubLinks_1 = require("@Components/CatalogMobileSubLinks");
const form_field_types_1 = require("@App/enum/form-field-types");
const is_hold_status_1 = require("@App/helpers/work-entities/utils/is-hold-status");
const catalogSearchFilters = [
    {
        name: 'Hold Filters',
        allowMultiple: true,
        filterFields: [
            {
                MLC_OVERCLAIM: {
                    type: form_field_types_1.FormFieldTypes.CHECKBOX,
                    checked: false,
                    name: 'MLC_OVERCLAIM',
                    label: '',
                    children: (0, is_hold_status_1.getHoldText)(104),
                },
            },
            {
                MLC_DISPUTE: {
                    type: form_field_types_1.FormFieldTypes.CHECKBOX,
                    checked: false,
                    name: 'MLC_DISPUTE',
                    label: '',
                    children: (0, is_hold_status_1.getHoldText)(105),
                },
            },
        ],
    },
];
const RightsholderCatalogSearch = () => {
    const { catalogSearchStore, userStore, uiStore, workStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_catalog');
        workStore.destroyViewWork();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ContentHeader_1.default, { title: 'Catalog' },
            react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.manage_works] },
                react_1.default.createElement(ButtonCreateNewWork_1.ButtonCreateNewWork, null))),
        uiStore.isMobile && react_1.default.createElement(CatalogMobileSubLinks_1.CatalogMobileSubLinks, null),
        react_1.default.createElement(CatalogSearch_1.default, { userStore: userStore, claimedShares: rightsholderStore.rightsholderClaimedShares, catalogSearchStore: catalogSearchStore, compactWorkComponentType: CatalogCompactWorkItem_1.default, extendedWorkComponentType: CatalogExtendedWorkItem_1.default, searchFilters: catalogSearchFilters })));
};
exports.default = (0, mobx_react_1.observer)(RightsholderCatalogSearch);
